import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useStyles } from './MiniArticleList_style.js'
import { Typography, Box } from '@material-ui/core'
import ArticleListCompactCard from 'cards/ArticleListCard/ArticleListCompactCard'

const MiniArticleList = (props) => {
    const { articles, category } = props
    const classes = useStyles()

    if (!articles) return null

    return (
        <Box className={classes.boxContainer}>
            <Box className={classes.titleContainer}>
                <Typography variant='h1' component='h2' className={classes.titlePage}>
                    <FormattedMessage id={`landing_recent_articles.news_${category}`} />
                </Typography>
            </Box>
            <Box className={classes.renderArticles}>
                {articles.map(article => {
                    return (
                        <ArticleListCompactCard
                            key={article.title}
                            article={article}
                        />
                    )
                })}
            </Box>
        </Box>
    )
}

export default MiniArticleList
